var map = {
	"./ion-action-sheet.entry.js": [
		1833,
		5
	],
	"./ion-alert.entry.js": [
		1834,
		6
	],
	"./ion-app_8.entry.js": [
		1835,
		7
	],
	"./ion-avatar_3.entry.js": [
		1836,
		18
	],
	"./ion-back-button.entry.js": [
		1837,
		19
	],
	"./ion-backdrop.entry.js": [
		1838,
		51
	],
	"./ion-button_2.entry.js": [
		1839,
		20
	],
	"./ion-card_5.entry.js": [
		1840,
		21
	],
	"./ion-checkbox.entry.js": [
		1841,
		22
	],
	"./ion-chip.entry.js": [
		1842,
		23
	],
	"./ion-col_3.entry.js": [
		1843,
		52
	],
	"./ion-datetime_3.entry.js": [
		1844,
		10
	],
	"./ion-fab_3.entry.js": [
		1845,
		24
	],
	"./ion-img.entry.js": [
		1846,
		53
	],
	"./ion-infinite-scroll_2.entry.js": [
		1847,
		54
	],
	"./ion-input.entry.js": [
		1848,
		25
	],
	"./ion-item-option_3.entry.js": [
		1849,
		26
	],
	"./ion-item_8.entry.js": [
		1850,
		27
	],
	"./ion-loading.entry.js": [
		1851,
		28
	],
	"./ion-menu_3.entry.js": [
		1852,
		29
	],
	"./ion-modal.entry.js": [
		1853,
		8
	],
	"./ion-nav_2.entry.js": [
		1854,
		15
	],
	"./ion-popover.entry.js": [
		1855,
		9
	],
	"./ion-progress-bar.entry.js": [
		1856,
		30
	],
	"./ion-radio_2.entry.js": [
		1857,
		31
	],
	"./ion-range.entry.js": [
		1858,
		32
	],
	"./ion-refresher_2.entry.js": [
		1859,
		11
	],
	"./ion-reorder_2.entry.js": [
		1860,
		17
	],
	"./ion-ripple-effect.entry.js": [
		1861,
		55
	],
	"./ion-route_4.entry.js": [
		1862,
		33
	],
	"./ion-searchbar.entry.js": [
		1863,
		34
	],
	"./ion-segment_2.entry.js": [
		1864,
		35
	],
	"./ion-select_3.entry.js": [
		1865,
		36
	],
	"./ion-slide_2.entry.js": [
		1866,
		56
	],
	"./ion-spinner.entry.js": [
		1867,
		13
	],
	"./ion-split-pane.entry.js": [
		1868,
		57
	],
	"./ion-tab-bar_2.entry.js": [
		1869,
		37
	],
	"./ion-tab_2.entry.js": [
		1870,
		16
	],
	"./ion-text.entry.js": [
		1871,
		38
	],
	"./ion-textarea.entry.js": [
		1872,
		39
	],
	"./ion-toast.entry.js": [
		1873,
		40
	],
	"./ion-toggle.entry.js": [
		1874,
		12
	],
	"./ion-virtual-scroll.entry.js": [
		1875,
		58
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 190;
module.exports = webpackAsyncContext;